// extracted by mini-css-extract-plugin
export default {"text_wrap":"AiTitle_text_wrap__cKzDZ","text":"AiTitle_text__c54TT","title":"AiTitle_title__yJ3-y"};